export default "__VITE_ASSET__DAjyHLTr__"